import * as React from 'react';
import { IFacetDTO, ITermDTO } from '../../DTO/search';
import { IContentProps } from '../../models/content-props';

interface IProps {
    facets: IFacetDTO[];
    contentProps: IContentProps;
    selectedTermIds: number[];
    onTermClick: (id: number) => void;
    onResetClick: () => void;
    isEventList: boolean;
}

export function Facets({ selectedTermIds, onTermClick, contentProps, onResetClick, facets, isEventList }: IProps) {
    const renderFacet = (value: IFacetDTO, index: number) => {
        return <Facet
            facet={value}
            key={index}
            selectedTermIds={selectedTermIds}
            onTermClick={onTermClick}
            isEventList={isEventList} />
    };

    if (!facets) {
        return null;
    }

    return (
        <div className="adage-search-filters">
            {isEventList ? <h2>Filter</h2> : <h2>Search Filters</h2>}          
            <a onClick={onResetClick}>{contentProps.resetButtonText}</a>
            {facets.map(renderFacet)}
        </div>
    );
};

interface IFacetProps {
    facet: IFacetDTO;
    selectedTermIds: number[];
    onTermClick: (id: number) => void;
    isEventList: boolean;
}

export function Facet({ selectedTermIds, facet, onTermClick, isEventList }: IFacetProps) {
    const [showAll, setShowAll] = React.useState(false);
    let displayFilterVisibilityToggle = facet.maxFiltersToDisplay > 0;

    if (isEventList) { 
        facet.maxFiltersToDisplay = 0;
        displayFilterVisibilityToggle = true;
    }

    const renderTerms = (value: ITermDTO, index: number) => {
        return (
            <Term
                key={index}
                selected={selectedTermIds.some((id) => id === value.id)}
                term={value}
                onTermClick={onTermClick}
            />
        );
    };

    const renderShowMore = (terms: ITermDTO[]) => {
        return (
            displayFilterVisibilityToggle && terms.length > facet.maxFiltersToDisplay && !showAll
        );
    };

    const renderShowLess = (terms: ITermDTO[]) => {
        return (
            displayFilterVisibilityToggle && terms.length > facet.maxFiltersToDisplay && showAll
        );
    };

    if (!facet.terms || facet.terms.length <= 0) {
        return null;
    }

    let splicedTerms =
        displayFilterVisibilityToggle && !showAll && facet.terms.length > facet.maxFiltersToDisplay
            ? facet.terms.slice().splice(0, facet.maxFiltersToDisplay)
            : facet.terms.slice();

    return (
        <div className="adage-search-filters-section">
            {isEventList ? 
                <fieldset>
                    {renderShowMore(facet.terms) && (
                        <button
                            type="button"
                            className="un-button adage-search-filters-display-toggle show-toggle"
                            onClick={() => setShowAll(true)}
                        >
                            {facet.displayName}
                        </button>
                    )}
                    {renderShowLess(facet.terms) && (
                        <button
                            type="button"
                            className="un-button adage-search-filters-display-toggle hide-toggle"
                            onClick={() => setShowAll(false)}
                        >
                            {facet.displayName}
                        </button>
                    )}
                    <ul className="adage-search-filters-list">{splicedTerms.map(renderTerms)}</ul>
                </fieldset>
                : 
                <fieldset>
                    <legend>{facet.displayName}</legend>
                    <ul className="adage-search-filters-list">{splicedTerms.map(renderTerms)}</ul>
                    {renderShowMore(facet.terms) && (
                        <button
                            type="button"
                            className="un-button adage-search-filters-display-toggle show-toggle"
                            onClick={() => setShowAll(true)}
                        >
                            {facet.viewMoreFiltersMessage || 'Show More'}
                        </button>
                    )}
                    {renderShowLess(facet.terms) && (
                        <button
                            type="button"
                            className="un-button adage-search-filters-display-toggle hide-toggle"
                            onClick={() => setShowAll(false)}
                        >
                            {facet.hideMoreFiltersMessage || 'Show Less'}
                        </button>
                    )}
                </fieldset>
            }
        </div>
    );
};

interface ITermProps {
    term: ITermDTO;
    selected: boolean;
    onTermClick: (id: number) => void;
}

export function Term({ term, onTermClick, selected }: ITermProps) {
    return (
        <li className="adage-search-filters-list-item">
            <input type="checkbox"
                onChange={() => onTermClick(term.id)}
                id={term.term}
                name={term.term}
                checked={selected}
                value={term.term} />
            <label htmlFor={term.term}>{term.displayName}</label>
            <span className="adage-search-filters-list-item-number">({term.hits})</span>
        </li>
    );
};
